import { render } from "./TaskApprovalView.vue?vue&type=template&id=7fe2e6e7"
import script from "./TaskApprovalView.vue?vue&type=script&lang=js"
export * from "./TaskApprovalView.vue?vue&type=script&lang=js"

import "./TaskApprovalView.vue?vue&type=style&index=0&id=7fe2e6e7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__